"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'topology'], function (_a, carmiProps) {
    var compData = _a.compData, compProps = _a.compProps, topology = _a.topology;
    var uri = compData.uri, placeHolderImage = compData.placeHolderImage;
    var link = carmiProps.link;
    var placeholderImage = __assign({}, placeHolderImage);
    placeholderImage.displayMode =
        compProps.displayMode === 'stretch' ? 'fill' : 'fit';
    return {
        uri: uri ? topology.mediaRootUrl + "media/" + uri : undefined,
        placeholderImage: placeholderImage,
        link: link,
    };
});
//# sourceMappingURL=FlashComponent.js.map